import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router, RouterLink, RouterOutlet } from '@angular/router';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { NgIf } from '@angular/common';
import { TranslocoPipe } from '@jsverse/transloco';

@Component({
    selector: 'app-reports.m-grid__item.m-grid__item--fluid.m-wrapper',
    templateUrl: './reports-base.component.html',
    styleUrls: ['./reports-base.component.css'],
    imports: [NgIf, RouterLink, RouterOutlet, TranslocoPipe]
})
export class ReportsBaseComponent implements OnInit, OnDestroy {

  reportName!: string;
  private $destroyed = new Subject<void>();

  constructor(
    private router: Router,
    private aRoute: ActivatedRoute,
  ) {
  }

  ngOnInit(): void {
    this.reportName = location.pathname.substr(9);
    this.router.events.pipe(takeUntil(this.$destroyed)).subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.reportName = location.pathname.substr(9);
      }
    });
  }

  ngOnDestroy(): void {
    this.$destroyed.next();
    this.$destroyed.complete();
  }
}
